import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// working_days and working_hours were removed in migration 20260327000000.
// Schedule intervals now live in instructor_schedule_intervals.
// Use get_instructor_schedule_intervals() RPC to read them.
interface AgendaConfig {
  instructor_id:    string;
  default_duration: number;
  is_public:        boolean;
  class_value:      number;
  currency:         string;
  created_at?:      string;
  updated_at?:      string;
}

export const useUserAgendaConfig = (userId?: string) => {
  const { data: config, isLoading, error } = useQuery({
    queryKey: ['user-agenda-config', userId],
    queryFn: async (): Promise<AgendaConfig | null> => {
      if (!userId) return null;

      try {
        // Use the safe RPC function to get any user's agenda config
        const { data, error } = await supabase.rpc('get_instructor_agenda_config_safe', {
          target_instructor_id: userId
        });

        if (error) throw error;

        // Check if data is empty array or null/undefined
        if (!data || (Array.isArray(data) && data.length === 0)) {
          return null; // No configuration found
        }

        // RPC returns an array, so get the first item
        return Array.isArray(data) && data.length > 0 ? data[0] : data;
      } catch (err) {
        // Gracefully handle any errors (RLS, network, etc.)
        console.error('Error fetching agenda config:', err);
        return null;
      }
    },
    enabled: !!userId,
  });

  return {
    config,
    isLoading,
    error: error?.message || null,
  };
};


